import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { LuFolderOpen, LuChevronRight } from 'react-icons/lu';
import MaterialsLevel from '../../../components/MaterialsLevel/MaterialsLevel'
import { useEffect, useState } from 'react';
import { fetchMaterials } from '../../../helpers/materials/fetchMaterials';
import { courseOf, fetchPlatformLessons, wantsPlatform } from '../../../helpers/materials/platformLessons';
import { hasExtraMaterials, isPlatformOnly } from '../../../helpers/langs';
import { PagesWrapper } from '../../../styles/components/PagesWrapper.styled';
import Loader from '../../../components/Loader/Loader';
import { PlatformLessonList } from '../../TeacherRoom/PlatformLessons/PlatformLessons';
import * as styled from '../../../components/MaterialsLevel/MaterialsLevel.styled';

function Materials() {
   const { data } = useSelector((state) => state.auth);
   const navigate = useNavigate();
   const [loading, setLoading] = useState(false);
   const [materials, setMaterials] = useState([]);
   // Учень на платформі (картка) і для його рівня є уроки → уроки платформи; інакше — Canva. null — ще вантажимо
   const [platformLessons, setPlatformLessons] = useState(null);
   const platformWanted = wantsPlatform(data);

   useEffect(() => {
    if (!platformWanted) return setPlatformLessons([]);
    fetchPlatformLessons(courseOf(data.ageGroup, data.englishLevel, data.accessType))
      .then(setPlatformLessons)
      .catch(() => setPlatformLessons([]));
   }, [platformWanted, data.ageGroup, data.englishLevel, data.accessType]);

   // Мова без Canva (іспанська) — завжди список уроків платформи (порожній — «ще немає уроків»), не Canva
   const usePlatform = isPlatformOnly(data.accessType) || platformLessons?.length > 0;

   useEffect(() => {
    if (platformLessons === null || usePlatform) return;
    fetchMaterials(setLoading, data.ageGroup, data.englishLevel, data.accessType, setMaterials)
   }, [platformLessons, usePlatform, data.ageGroup, data.englishLevel, data.accessType]);

   if (platformLessons === null) return <PagesWrapper><Loader /></PagesWrapper>;

   return (
     <PagesWrapper>
       {usePlatform ? (
         <PlatformLessonList title="Матеріали" englishLevel={data.englishLevel} lessons={platformLessons}>
           {hasExtraMaterials(data.accessType) && <styled.Extra onClick={() => navigate('additional-materials')}>
             <styled.ExtraIcon>
               <LuFolderOpen size={22} />
             </styled.ExtraIcon>
             <styled.ExtraText>
               <b>Додаткові матеріали</b>
               <small>Шпаргалки з граматики для повторення</small>
             </styled.ExtraText>
             <LuChevronRight size={22} />
           </styled.Extra>}
         </PlatformLessonList>
       ) : (
         <MaterialsLevel loading={loading} topTitle={'Матеріали'} materials={materials} englishLevel={data.englishLevel} isStudent showExtra={hasExtraMaterials(data.accessType)}/>
       )}
     </PagesWrapper>
   );
}
 
 export default Materials;
